import classNames from 'classnames';

export const ColorDot: React.FC<{
  as?: 'div' | 'button';
  color: string;
  text?: string;
  active?: boolean;
  disableHover?: boolean;
  onClick?: (e: React.MouseEvent<HTMLElement>) => void;
}> = ({ as = 'button', color, active, text, disableHover = false, onClick }) => {
  const Component = as;
  return (
    <Component
      className={classNames(
        'ms-[5px] grid h-[30px] w-[30px] items-center justify-center rounded-full text-[12px] ring-1 ring-neutrals-black-50 ring-offset-0',
        { 'ring-offset-4': active },
        { 'hover:ring-offset-4': !disableHover },
      )}
      style={{ background: color }}
      onClick={onClick}
    >
      {text}
    </Component>
  );
};
